import { AddCustomerEmployeeContactInput, EditCustomerEmployeeContactInput } from "..";

export class EditCustomerEmployeeInput {
    public id: number = 0;
    public fullName: string = '';
    public email: string = '';
    public businessRoleId: number = 0;
    public personalPictureFile: string = '';
    public personalPictureFileName: string = '';
    public addCustomerEmployeeContacts: Array<AddCustomerEmployeeContactInput> = [];
    public editCustomerEmployeeContacts: Array<EditCustomerEmployeeContactInput> = [];
    public deleteCustomerEmployeeContacts: Array<number> = [];
}
